function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "link",
  transform: "translate(-20853 -1564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2342",
  "data-name": "Rectangle 2342",
  transform: "translate(20853 1564)",
  fill: "#fff",
  stroke: "#a7afb9",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 26,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 27,
  height: 25,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "link-2",
  "data-name": "link",
  transform: "translate(20858.006 1567.995)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1301",
  "data-name": "Path 1301",
  d: "M10,9.749a3.522,3.522,0,0,0,5.311.38l2.113-2.113a3.521,3.521,0,1,0-4.98-4.98l-1.211,1.2",
  transform: "translate(-2.46 0)",
  fill: "none",
  stroke: "#a7afb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1302",
  "data-name": "Path 1302",
  d: "M10.451,10.407a3.522,3.522,0,0,0-5.311-.38L3.027,12.14a3.521,3.521,0,1,0,4.98,4.98l1.2-1.2",
  transform: "translate(0 -2.146)",
  fill: "none",
  stroke: "#a7afb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})));

var SvgCopyLinkSmallDisabled = function SvgCopyLinkSmallDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyLinkSmallDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy_link_small_disabled.ec7459ff.svg";
export { ForwardRef as ReactComponent };